import { Directive, TemplateRef, Component, Input } from '@angular/core'

@Directive({
  selector: 'ng-template[selectOptionItem]',
  standalone: false,
})
export class SelectOptionItemDirective {
  constructor(public templateRef: TemplateRef<any>) {}
}

@Directive({
  selector: 'ng-template[selectItemLabel]',
  standalone: false,
})
export class SelectItemLabelDirective {
  constructor(public templateRef: TemplateRef<any>) {}
}
